<template>
  <imports-select-submissions-table
    :value="selectedIds"
    :submissions="submissions"
    :assignment-link="assignmentLink"
    :show-open-in-lms="showOpenInLms"
    :loading="loading"
    @input="onInput"
  />
</template>

<script>
import importApi from "@/api/requests/import";
import errorHandler from "./errorHandler";
import ImportsSelectSubmissionsTable from "./imports_select_submissions_table.vue";
import { GC_SUBMISSION_STATES, PLATFORMS } from "@/constants";

export default {
  name: "ImportsSelectSubmissions",

  components: {
    ImportsSelectSubmissionsTable,
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    classId: {
      type: [String, Number],
      default: "",
    },
    assignmentId: {
      type: [String, Number],
      default: "",
    },
    assignmentLink: {
      type: String,
      default: null,
    },
    platformKey: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      loading: false,
      selectedIds: [],
      submissions: [],
    };
  },
  computed: {
    showOpenInLms() {
      return [PLATFORMS.GOOGLE].includes(this.platformKey);
    },
  },

  watch: {
    classId() {
      this.selectedIds = [];
      this.submissions = [];
    },
    assignmentId() {
      this.submissions = [];
      this.fetchData();
    },
  },

  mounted() {
    this.fetchData();
  },
  methods: {
    emitSelectedIds() {
      this.$emit("input", this.selectedIds);
    },

    onInput(value) {
      this.selectedIds = value;
      this.emitSelectedIds();
    },

    async fetchData() {
      try {
        if (!this.classId || !this.assignmentId) {
          return;
        }
        this.loading = true;
        const { data } = await importApi[this.platformKey].getSubmissions(
          this.id,
          this.classId,
          this.assignmentId
        );
        this.submissions = data.submissions.map((s) => ({
          ...s,
          disabled: s.status === "UnableToImport",
        }));
        this.loading = false;
        this.$emit("loaded");

        // NOTE: if value prop is empty, select all submissions with status "NotImported"
        if (this.value.length === 0) {
          this.selectedIds = this.submissions
            .filter((s) => {
              if (s.state) {
                return (
                  s.status === "NotImported" &&
                  s.state === GC_SUBMISSION_STATES.TURNED_IN
                );
              }

              return s.status === "NotImported";
            })
            .map((s) => s.id);
          this.emitSelectedIds();

          return;
        }

        // NOTE: add only available submissions to selectedIds array,
        this.value.forEach((id) => {
          const index = this.submissions.findIndex((s) => s.id === id);

          if (index > -1) {
            this.selectedIds = [
              ...this.selectedIds,
              this.submissions[index].id,
            ];
          }
        });
        this.emitSelectedIds();
      } catch (error) {
        this.loading = false;
        this.$emit("loaded");

        errorHandler({
          vm: this,
          error,
          message:
            "There was a problem fetching your submissions. Please try again.",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
